var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-input",
        {
          attrs: { placeholder: "Promo Code", clearable: "" },
          on: { input: _vm.onInput },
          model: {
            value: _vm.promoCodeValue,
            callback: function($$v) {
              _vm.promoCodeValue = $$v
            },
            expression: "promoCodeValue"
          }
        },
        [
          _c(
            "el-button",
            {
              attrs: {
                slot: "append",
                disabled: !_vm.promoCodeValue,
                loading: _vm.loading
              },
              on: { click: _vm.checkPromoCode },
              slot: "append"
            },
            [_vm._v("Apply")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.couponDetailsFromState != null
        ? _c("el-tag", { attrs: { type: "success" } }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.couponDetailsFromState.couponCode) +
                " applied: " +
                _vm._s(_vm.couponDetailsFromState.periodInDays) +
                "-day trial activated.\n  "
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d626955c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d626955c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/promoCodeInput.vue
// module id = null
// module chunks = 